module.exports = __webpack_public_path__ + "static/img/search@2x.955f3b4a.png";